import type { JSX } from 'react';

import clsx from 'clsx';

import { textColorClasses } from '@/components/classes/textColorClasses';
import { testIds } from '@/components/constants/testIds';
import { composeSizeClasses } from '@/components/functions/composeSizeClasses';
import type { Adaptive } from '@/components/types/Adaptive';
import type { Color } from '@/components/types/Color';
import type { IconType } from '@/components/types/IconType';
import type { Size } from '@/components/types/Size';
import { componentsConfig } from '@/config/componentsConfig';

type IconProps = {
    icon: IconType;
    size?: Adaptive<Size>;
    color?: Color;
    dynamicColor?: string;
    className?: string;
    testId?: string;
};

export default function Icon({
    icon: Icon,
    size = componentsConfig.icon.size,
    color = componentsConfig.icon.color,
    dynamicColor,
    className,
    testId = testIds.icon.base,
}: IconProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <Icon
            data-testid={testId}
            className={clsx(composeSizeClasses(size), textColorClasses[color], className)}
            style={{ color: dynamicColor }}
        />
    );
}
